import React from 'react'
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

const Unauthorized = ({ message }) => {
    const navigate = useNavigate();

    return (
        <div className="status_page">
            <div className="status_icon"><ShieldAlert size="32" /></div>
            <span className="status_code">403 · Access Denied</span>
            <h1>You can't access this</h1>
            <p>{message || "Your account doesn't have permission to view this page, or this app isn't linked to your account."}</p>
            <button className="pill_button" onClick={() => navigate("/")}>Back to Dashboard</button>
        </div>
    )
}

export default Unauthorized;
